export const APP_INPUT_CLASS =
  'w-full h-9 px-3 py-0 border border-app-border rounded-md text-sm text-app-text placeholder:text-app-text-subtle focus:ring-2 focus:ring-pipedrive-blue/20 focus:border-pipedrive-blue outline-none bg-app-surface';

export const APP_TEXTAREA_CLASS =
  'w-full min-w-0 px-3 py-2 border border-app-border rounded-md text-sm text-app-text placeholder:text-app-text-subtle focus:ring-2 focus:ring-pipedrive-blue/20 focus:border-pipedrive-blue outline-none bg-app-surface';

export const APP_SELECT_TRIGGER_CLASS = '!min-h-0 h-9 !py-0';

/** Gruppentitel in Filter-Popovern: ohne Caps und Bold, führt über Größe und Farbe. */
export const FILTER_GROUP_LABEL_CLASS = 'text-xs font-medium text-app-text-muted';

export const APP_BTN_OUTLINE_CLASS =
  'inline-flex h-9 items-center justify-center gap-2 shrink-0 rounded-md border border-app-border bg-app-surface px-3.5 text-sm font-medium text-app-text-muted hover:bg-app-hover disabled:opacity-40 transition-colors';

export const APP_BTN_PRIMARY_CLASS =
  'inline-flex h-9 items-center justify-center gap-2 shrink-0 rounded-md bg-pipedrive-blue px-3.5 text-sm font-semibold text-white hover:bg-blue-700 disabled:opacity-40 transition-colors';

export const APP_BTN_DANGER_CLASS =
  'inline-flex h-9 items-center justify-center gap-2 shrink-0 rounded-md bg-red-600 px-3.5 text-sm font-medium text-white hover:bg-red-700 disabled:opacity-40 transition-colors';

/**
 * `app-btn-danger-outline` steuert die Dark-Mode-Fläche (siehe `src/index.css`) — ohne sie
 * bleibt im Dark Mode nur der rote Rand um die blanke Oberfläche stehen.
 */
export const APP_BTN_DANGER_OUTLINE_CLASS =
  'app-btn-danger-outline inline-flex h-9 items-center justify-center gap-2 shrink-0 rounded-md border border-red-300 bg-app-surface px-3.5 text-sm font-medium text-red-600 hover:bg-red-50 disabled:opacity-40 transition-colors';
